import { axiosAPI } from 'utils';
import { AI_AUTHORING_BACKEND_CAPABILITY } from 'pages/Admin/admin-pages/tools/AiActivityAuthoring/aiAuthoringCapability';

// Reads ONLY the AI Activity Authoring visibility flag via the Make-side
// (JWT-authenticated) endpoint.
//
// Capability guard: while the backend support is not deployed
// (AI_AUTHORING_BACKEND_CAPABILITY === false), this makes NO request at all and
// resolves to { success:false, enabled:false, unsupported:true } — so a UI landing
// on the old backend produces zero new requests/errors. Once the backend ships,
// flip the capability flag and this calls the real endpoint, failing closed to
// { enabled:false } on any error.
const aiAuthoringSettingsAPI = {
  get() {
    if (!AI_AUTHORING_BACKEND_CAPABILITY) {
      return Promise.resolve({ success: false, enabled: false, unsupported: true });
    }
    return axiosAPI
      .get('api/flink-make/ai-authoring-settings')
      .then((res) => res.data)
      .catch(() => ({ success: false, enabled: false }));
  },
};

export default aiAuthoringSettingsAPI;
